<app-dialog
	modalTitle="Excluir dependente"
	titleButton="Salvar"
	[hideFooter]="false"
	[disabled]="form.invalid"
	(dialogClose)="closeModal()"
	(dialogSave)="deleteDependent()"
>
	<div class="container" [formGroup]="form">
		<div class="line">
			<mat-form-field
				class="form-field"
				title="Nome completo"
				appearance="outline"
			>
				<mat-label>Nome completo</mat-label>
				<input
					type="text"
					matInput
					placeholder="Nome completo"
					formControlName="name"
				/>
			</mat-form-field>
			<mat-form-field
				class="form-field"
				title="Data de Exclusão"
				appearance="outline"
			>
				<mat-label>Data de exclusão</mat-label>
				<input
					matInput
					placeholder="Data de exclusão"
					formControlName="dateOfExclusion"
					[matDatepicker]="picker"
				/>
				<mat-datepicker-toggle matSuffix [for]="picker">
					<mat-icon
						matDatepickerToggleIcon
						svgIcon="sanus-calendar-blue"
					></mat-icon>
				</mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
				<mat-error *ngIf="form.get('dateOfExclusion')?.hasError('required')">
					Campo obrigatório
				</mat-error>
			</mat-form-field>
		</div>
	</div>
</app-dialog>
